import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pascalCaseAddSpaces' })
export class PascalCaseAddSpacesPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/([A-Z][a-z]+)|([0-9]+)/g, ' $1$2').trim();
  }
}
